<template>
  <a-table :columns="columns" :data-source="data" :pagination="false">

    <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
      {{ record.description }}
    </p>
  </a-table>
</template>
<script>
  const columns = [
    { title: '后台更新公告', dataIndex: 'msg', key: 'msg' },
  ];

  const data = [
    {
      key: 1,
      msg: '2022-09-14更新优化内容',
      description: '电子真人升级投注增加批量修改备注功能',
    },
    {
      key: 2,
      msg: '2022-09-20更新优化内容',
      description: '翻本金排行榜增加秒数自动刷新查询功能,在线付款汇率如开启显示且正常填写数字前端及换显示汇率试算功能',
    },
    {
      key: 3,
      msg: '2022-09-29更新优化内容',
      description: '1.交易帐号功能-账号管理、出售、回收、出价与评估管理增加导出功能 2.翻本金排行榜查询增加勾选导出功能',
    },
    {
      key: 4,
      msg: '2022-11-16更新优化内容',
      description: '借呗订单管理-历史订单数据,增加"借呗数据修复"功能,可针对逾期借款异常,最高可以借还款数据重新统计...',
    },
    {
      key: 5,
      msg: '2023-07-12更新优化内容',
      description: '活动申请记录添加新功能-如收到新申请订单需有声音提示',
    },
    {
      key: 6,
      msg: '2023-08-17更新优化内容',
      description: '新增优惠活动中添加上传图片/上传影片之功能',
    },
    {
      key: 7,
      msg: '2025-11-04更新优化内容',
      description: '◆新增联动现金后台的存款，判断未存款会员，取消当期俸禄\n◆新增电子、真人排行榜联动现金后台的有效投注\n◆活动优惠大厅添加限制次数',
    }
  ];

  export default {
    data() {
      return {
        data,
        columns,
      };
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/default.vue